import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/nc-freedom-popup-dealer")({
  component: () => <Outlet />,
});
